export default __webpack_public_path__ + "static/media/G0320.34I-26134_-17342_0.1666261860000.adf90c1c.jpg";